"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugify = void 0;
exports.slugify = (name) => name
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "")
    .substring(0, 130) || "q";
//# sourceMappingURL=slugify.js.map